import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { useLoader } from "../../../utils/common";
import ImpactImages from "./Impactimages";

const API_URL = "/admin/about-us/impact";

const AddImpact = ({ handleClose }) => {
  const { postData } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [files, setFiles] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { sort_order: 0 } });

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("description", data.description);
      sendData.append("sort_order", data.sort_order || 0);
      files.forEach((f) => sendData.append("images", f)); // in the order shown, the first is the thumbnail

      const response = await withLoader(() => postData(API_URL, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Impact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="e.g. 7 years of annual eye camps for Warkaris, with free eye tests and spectacles"
                        className={classNames("w-100", { "is-invalid": errors?.description })}
                        {...register("description", { required: "Description is required" })}
                      />
                    </InputGroup>
                    {errors.description && <span className="text-danger">{errors.description.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Images</Form.Label>
                    <ImpactImages files={files} setFiles={setFiles} />
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="number" min={0} className="w-100" {...register("sort_order")} />
                    </InputGroup>
                    <small className="text-muted">Lower numbers show first.</small>
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default AddImpact;